<template>
  <header class="row__center__between px-16 py-8 bg-surface-4">
    <nav class="row__center g-16">
      <router-link
        :to="{name: 'Home'}"
        class="row__center g-4"
      >
        <img
          src="/code.svg"
          alt="Logo"
          class="logo"
        />
        <span class="onprimary">Adriano Vieira</span>
      </router-link>
    </nav>
    <div class="row__center g-16">
      <language-selector />
    </div>
  </header>
</template>

<script>
import LanguageSelector from './LanguageSelector.vue'

export default {
  name: 'AppNavbar',
  components: {
    LanguageSelector,
  },
}
</script>

<style lang="scss" scoped>
header {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);

  img {
    width: 24px;
    aspect-ratio: 1;
  }
}
</style>
